var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"checkbox",on:{"click":function($event){return _vm.$emit('change')}}},[(_vm.checked)?_c('span',{staticClass:"check"}):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }